/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caseslistemptyhint3Inputs */

const en_caseslistemptyhint3 = /** @type {(inputs: Caseslistemptyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start one to record your renovation.`)
};

const pt_caseslistemptyhint3 = /** @type {(inputs: Caseslistemptyhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie um para registar a sua obra.`)
};

/**
* | output |
* | --- |
* | "Start one to record your renovation." |
*
* @param {Caseslistemptyhint3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const caseslistemptyhint3 = /** @type {((inputs?: Caseslistemptyhint3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caseslistemptyhint3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_caseslistemptyhint3(inputs)
	return pt_caseslistemptyhint3(inputs)
});
export { caseslistemptyhint3 as "casesListEmptyHint" }